import { create } from 'zustand';
import { SupplierDetailSlice, createSupplierDetailSlice } from './supplier-detail';

export type SupplierDetailStore = SupplierDetailSlice;

export const useStore = create<SupplierDetailStore>()((...a) => ({
  ...createSupplierDetailSlice(...a),
}));
